import React from "react";

const ForgotPassword = () => (
  <div className="bg-secondary p-8 rounded-lg shadow-lg w-96">
    <h2 className="text-2xl font-semibold mb-6">Forgot Password</h2>
    <form>
      <div className="mb-4">
        <label className="block text-secondary mb-2" htmlFor="email">
          Email
        </label>
        <input
          type="email"
          id="email"
          className="w-full p-2 rounded-md bg-primary border border-secondary focus:outline-none focus:border-accent"
        />
      </div>
      <button
        type="submit"
        className="w-full bg-accent text-primary py-2 rounded-md hover:bg-primary hover:text-accent transition duration-200"
      >
        Submit
      </button>
    </form>
  </div>
);

export default ForgotPassword;
